import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Space,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";

import { fetchSsoProvider } from "@api";

import { openLoginPopup } from "@pages/login/utils";

import { MarketingNavbar } from "./components";

export const SSOSignIn = () => {
  const [email, setEmail] = useState("");

  const onFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    fetchSsoProvider(email)
      .then((authProvider) => openLoginPopup(authProvider))
      .catch((err) =>
        showNotification({
          title: "Error signing in",
          message: `Could not find SSO provider for ${email}: ${err.body?.error}`,
          color: "red",
        })
      );
  };

  return (
    <Box
      sx={(theme) => ({
        backgroundImage: theme.fn.gradient({
          from: theme.colors["teal"][0],
          to: "white",
          deg: 120,
        }),
        height: "100vh",
      })}
    >
      <MarketingNavbar />
      <Container>
        <Space h={80} />
        <Title order={1} style={{ fontSize: "36px" }}>
          Sign in with{" "}
          <Text color="teal" style={{ display: "inline" }}>
            SSO
          </Text>
        </Title>
        <Space h="md" />
        <form onSubmit={onFormSubmit}>
          <Stack spacing="lg" sx={{ maxWidth: "400px" }}>
            <TextInput
              label="Email address"
              placeholder="you@example.com"
              type="email"
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" color="teal" size="md">
              Continue to your provider
            </Button>
          </Stack>
        </form>
      </Container>
    </Box>
  );
};
